<template>
	<div>
		<mt-field label="请选择城市" disabled v-model="MealCityDictVal" @click.native="selectCity">
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-arrow-right"></use>
			</svg>
		</mt-field>
		<div class="mettingType">
			<!--<mt-field label="会议类型" disabled v-model="mettingType.txt" @click.native="Handle('mettingType')" v-if="MealCityDictVal">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>
            </mt-field>-->
		</div>
		<div class="search">
			<mt-button type="default" size="large" @click="search">开始搜索</mt-button>
		</div>
	</div>
</template>
<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	// import PopupFullPicker from '@/components/popup-full-picker'
	import selectInfo from '@/components/selectInfo.js'
	import { commonQuery as commonQueryValidator } from '@/validatorConfig/commonQuery';
	import colorList from '@/config';
	import config from '@/api/config'
	import { getAllCookies } from 'tiny-cookie'
	export default {
		extends: selectInfo,
		data() {
			return {
				header: {
					deviceType: '',
					deviceId: '',
					// ip: '',
					mac: ''
				}
			}
		},
		mounted() {
			this.getDeviceAsync()
		},
		computed: {
			...mapGetters([
				'MealCityDictVal',
				'MealProvinceDictVal',
				'mettingType',
                'MealCityGPS',
                'PingCityId'
			])
		},
		methods: {
			...mapActions([
				'GetOpenMealUrlPromise',
				'GetOrderUrl',
				'getMePromise',
				'restPromise',
				'saveCacheData',
				'MeiTuanLogin'
			]),
			async getDeviceAsync() {
				try {
					var returnValue = this.JSbridge.call({
						method: "SMDataStorage.getDevice",
						callback: this.RegisterDeviceAsync
					});
					if (returnValue) {
						await this.RegisterDeviceAsync(returnValue);
					}
				} catch (e) {
				}
			},
			RegisterDeviceAsync(result) {
				this.header = {
					deviceType: result.deviceData.brand || result.deviceData.model || result.deviceData.localizedModel,
					deviceId: result.deviceData.deviceId,
					// ip: result.deviceData.deviceId,
					mac: result.deviceData.deviceId
				}
			},
			selectCity() {
				const currentRoute = this.$route.path
				this.$router.push({
					path: '/selectCity',
					query: {
						mealQueryType: 2,
						backRoute: currentRoute
					}
				})
			},
			query() {
				let params = {

				}
			},
			async search() {
				var params = {
					cityDictVal: this.MealCityDictVal,
					// typeMeetVal: this.mettingType.val
					tenantId: this.iStorage.get('tenantId')
				}
				const validateResult = this.validate(params, commonQueryValidator);
				if(!validateResult) return;
				let queryType = this.iStorage.get('queryType') || "meal";
				switch(queryType) {
					case "meal":
						// this.mealSearch(params);
						this.openMeal()
						break;
					case "venue":
						this.venueSearch();
						break;
					case "car":
						this.carSearch();
						break;
					case "iEvent":
						this.openMeal()
						// this.getOrderUrl({
						// 	url: "GetMealOrderUrl",
						// 	itemId: null
						// })
						break;
					case "iEventSYT":
						this.openMeal()
						// this.getSYTUrl()
						break;
				}
			},

		generateUUID() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0,
					v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},
			// 获取餐厅地址
		async openMeal(){
			let mealCombineData = [];
			// 餐厅库地址
			let eventData = JSON.parse(this.$cookies.get('eventData'))
			eventData = {
				...eventData,
				province: this.MealProvinceDictVal,
				cityDictVal: this.MealCityDictVal,
				pingCityId: this.PingCityId,
				city: this.MealCityDictVal,
				gps: this.MealCityGPS,
				tenantId: this.iStorage.get("tenant_id"),
				tenant_code: 'roche',
			}
			let webappUrl = this.iStorage.getUriSetting("webapp-mshop");
			let urlParams = `/index?tenantcode=roche&changeshop=true`;
			let loadUrl = webappUrl + urlParams;
			// 数据持久化保存数据
			let eventDataParams = {
                Data: {
                    data: {
                        eventData: eventData || {},
						token: this.iStorage.get("token"),
						tenant_code: 'roche',
						tenant: 'roche'
                    }
                }
            }
			const sessionIdData = await this.saveCacheData(eventDataParams)
			loadUrl = loadUrl + '&sessionId=' + sessionIdData.content
			mealCombineData.push({
				selected: 'https://spkg.smartmice.cn/resources/images/imeal/jh_ele_gd_xms_focus.png',
				normal: 'https://spkg.smartmice.cn/resources/images/imeal/jh_ele_gd_xms_blur.png',
				url: loadUrl
			})
			this.$cookies.setCookie("eventData", JSON.stringify(eventData), {
				domain: window.idomain
			});
			this.$cookies.setCookie("eventData", JSON.stringify(eventData));
			//获取美团地址`
			let itemId = this.generateUUID();
			let meituanParams ={
				ItemId: itemId,
				latitude: this.MealCityGPS.latitude,
				longitude: this.MealCityGPS.longitude
			}
			const meituanRes = await this.MeiTuanLogin(meituanParams)
			if (meituanRes && meituanRes.success) {
				this.meituanLoginUrl = meituanRes.content;
			}else{
				return
			}
			mealCombineData.push({
				selected: 'https://spkg.smartmice.cn/resources/images/imeal/wm_mt_focus.png',
				normal: 'https://spkg.smartmice.cn/resources/images/imeal/wm_mt_blur.png',
				url: this.meituanLoginUrl
			})
			// 罗氏获取商宴通地址
			// var getMeRes = await this.getMePromise({})
			// 	if(getMeRes && getMeRes.success) {
			// 		let sytParams = {
			// 			a1OrderId: "",
			// 			city: this.MealCityDictVal,
			// 			jobnum: getMeRes.content.userId,
			// 			name: getMeRes.content.dspName,
			// 			phone: getMeRes.content.phoneNumber,
			// 			peopleNum: 2,
			// 		}
			// 		const sytRes = await this.restPromise(sytParams)
			// 		if(sytRes && sytRes.success){
			// 			mealCombineData.push({
			// 				selected: 'https://spkg.smartmice.cn/resources/images/imeal/syt_focus.png',
			// 				normal: 'https://spkg.smartmice.cn/resources/images/imeal/syt_blur.png',
			// 				url: sytRes.content.url,
			// 				headerData: {
			// 					...sytRes.content.identifierHeader,
			// 					...this.header
			// 				},
			// 			})
			// 		}else{
			// 			return
			// 		}
			// 	}
			this.goMeal(mealCombineData)
		},
		//选择餐厅
		async goMeal(mealCombineData) {
			var _this = this;
			openMealSite();
			function openMealSite() {
				const options = {
					method: "SMGeneral.openNewWebSiteForResult",
					postData:{
						loadUrl: 'mealCombineData',
						cookieData: getAllCookies(),
						mealCombineData: mealCombineData,
					},
					callback: (viewData) => {

					}
				};
				_this.JSbridge.call(options);
			}
		},
			async getSYTUrl() {
				var res = await this.getMePromise({})
				if(res && res.success) {
					let params = {
						a1OrderId: "",
						city: this.MealCityDictVal,
						jobnum: res.content.userId,
						name: res.content.dspName,
						phone: res.content.phoneNumber,
						peopleNum: 2,
					}
					const res1 = await this.restPromise(params)
					if(res1 && res1.success) {
						this.openSYT(res1);
					}
				}
			},
			//打开商宴通外部站点
			openSYT(data) {
				const tenant = window.document.documentElement.getAttribute("data-theme") || this.iStorage.get('tenant_code');
				const options = {
					method: "SMGeneral.openNewWebSiteForResult",
					postData: {
						loadUrl: data.content.url,
						headerData: {
							...this.header,
							...data.content.identifierHeader
						},
						browserMode: {
							navBarVisibilty: true,
							titleTextColor: "#ffffff",
							navBackgroundColor: colorList[tenant]
						}
					},
					callback: function() {}
				};
				this.JSbridge.call(options);
			},
			//获取外部站点url
			async getOrderUrl(options) {
				let params = {
					latitude: this.MealCityGPS.latitude,
					longitude: this.MealCityGPS.longitude
				};
				let response = await this.GetOrderUrl(params);
				if(response && response.success) {
					if(response.content.hasOwnProperty('url')){
						this.openDianPing(response.content.url);
					}else{
						this.openDianPing(response.content);
					}
				}
			},
			//打开外部站点
			openDianPing(url) {
				console.log(url);
				const tenant = window.document.documentElement.getAttribute("data-theme") || this.iStorage.get('tenant_code');
				const options = {
					method: "SMGeneral.openNewWebSiteForResult",
					postData: {
						loadUrl: url,
						browserMode: {
							navBarVisibilty: true,
							titleTextColor: "#ffffff",
							navBackgroundColor: colorList[tenant]
						}
					},
					callback: function() {}
				};
				this.JSbridge.call(options);
			},
            // 餐厅查询
            mealSearch() {
                var webappUrl, urlParams;
                webappUrl = this.iStorage.getUriSetting("webapp-mshop");
                urlParams = `/index?tenantcode=roche&changeshop=true`;
                webappUrl = webappUrl + urlParams;
                const cityOptions = {
                    provinceDictVal: this.MealProvinceDictVal,
                    cityDictVal: this.MealCityDictVal,
                    pingCityId: this.PingCityId,
                    gps: this.MealCityGPS,

                }

                this.openSearchWebapp(webappUrl, cityOptions)
            },
            // 公共方法
            openSearchWebapp(webappUrl, cityOptions) {
                var token = this.iStorage.get("token");
                var tenantId = this.iStorage.get("tenant_id");
                var rnd = new Date().getTime();
				let eventData = JSON.parse(this.$cookies.get('eventData'))
				eventData = {
					...eventData,
                    province: cityOptions.provinceDictVal,
                    cityDictVal: cityOptions.cityDictVal,
                    pingCityId: cityOptions.pingCityId,
                    city: cityOptions.cityDictVal,
                    gps: cityOptions.gps,
                    tenantId: this.iStorage.get("tenant_id"),
                    tenant_code: 'roche',
				}
                this.$cookies.setCookie("eventData", JSON.stringify({
					eventData
                }), {
                    domain: window.idomain
                });
                this.$cookies.setCookie("eventData", JSON.stringify(eventData));
                this.JSbridge.openWebapp({
                    loadUrl: `${webappUrl}&rnd=${rnd}&tenantId=${tenantId}&tenant_code=roche`
                });
            },
			venueSearch() {
				const ivenueUrl = (this.iStorage.get("Uris")["Uris"])["webapp-ivenue"] + "/venueList";
				this.openWebapp(ivenueUrl)
			},
			carSearch() {
				const icarUrl = (this.iStorage.get("Uris")["Uris"])["webapp-icar"] + "/item";
				this.openWebapp(icarUrl)
			},
			openWebapp(loadUrl) {
				const urlParams = location.href.substring(location.href.indexOf("?"));
				let eventData = JSON.parse(this.$cookies.get('eventData'))
				eventData = {
					...eventData,
					cityDictVal: this.MealCityDictVal,
					province: this.MealProvinceDictVal
				}
				this.$cookies.setCookie("eventData", JSON.stringify(eventData), {
					domain: window.idomain
				});
				this.$cookies.setCookie("eventData", JSON.stringify(eventData));
				this.JSbridge.openWebapp({
					loadUrl: loadUrl + urlParams
				});
			}
		},
		// components: {
		//     PopupFullPicker
		// }
	}
</script>
<style lang="scss">
	.mettingType {
		height: 48px;
	}
</style>



// WEBPACK FOOTER //
// src/components/CommonQuery.vue